import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import OTPInput from "react-otp-input";
import { useUser } from "../../../contexts/userContext";
import { CartContext } from "../../../contexts/cartContext";

const BuyerLogin = () => {
    const [buyerMobile, setBuyerMobile] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isVisibleLogin, setIsVisibleLogin] = useState(true);
    const [isVisibleOTP, setIsVisibleOTP] = useState(false);
    const [otp, setOtp] = useState("");
    const [otp2, setOtp2] = useState("");
    const navigate = useNavigate();
    const { loginUser } = useUser(); 
    const { clearCart, clearWishlist } = useContext(CartContext);

    // Function to sync cart and wishlist data
    const syncCartAndWishlist = async () => {
        const cartData = JSON.parse(localStorage.getItem("cart")) || [];
        const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const buyer_id = userInfo?.buyer_id;

        if (!buyer_id) {
            console.error("User ID not found in local storage");
            return;
        }

        // Sync Cart
        if (cartData.length > 0) {
            for (const cartItem of cartData) {
                try {
                    const payload = {
                        customer_id: buyer_id,
                        product_id: cartItem.product_id,
                    };
                    await fetch("https://igapi.heuristticminds.com/api/CartList/Add-SaveCartList", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload),
                    });
                    console.log("Cart item synced successfully:", cartItem.product_id);
                } catch (error) {
                    console.error("Error syncing cart item:", cartItem.product_id, error);
                }
            }
        }

        // Sync Wishlist
        if (wishlistData.length > 0) {
            for (const wishlistItem of wishlistData) {
                try {
                    const payload = {
                        customer_id: buyer_id,
                        product_id: wishlistItem.product_id,
                    };
                    await fetch("https://igapi.heuristticminds.com/api/WishList/Add-SaveWishList", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload),
                    });
                    console.log("Wishlist item synced successfully:", wishlistItem.product_id);
                } catch (error) {
                    console.error("Error syncing wishlist item:", wishlistItem.product_id, error);
                }
            }
        }

        // Clear cart and wishlist after sync
        localStorage.removeItem("cart");
        localStorage.removeItem("wishlist");
        clearCart();
        clearWishlist();
    };

    // Create local storage after login
    const createLocalStore = async () => {
        const url = `https://igapi.heuristticminds.com/api/BuyerList/Login-ValidateBuyerMobile?BuyerMobile=${buyerMobile}`;
        try {
            const response = await fetch(url);
            const apiData = await response.json();
            if (apiData && apiData.buyerName) {
                loginUser(apiData);
                localStorage.setItem("user-info", JSON.stringify(apiData));
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // Handle login action
    const handleLogin = async (event) => {
        event.preventDefault();
        const storedUserInfo = localStorage.getItem("user-info");
        if (storedUserInfo) {
            alert("User info already stored.");
            return;
        }

        if (!buyerMobile) {
            setErrorMessage("Please enter your Mobile No.");
            return;
        }

        const url = `https://igapi.heuristticminds.com/api/BuyerList/Login-ValidateBuyerMobile?BuyerMobile=${buyerMobile}`;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                setIsVisibleOTP(false);
                setIsVisibleLogin(false);
                return;
            }

            const apiData = await response.json();
            if (apiData && apiData.buyerName) {
                const generatedOtp = generateOtp();
                setOtp2(generatedOtp.toString());
                alert(generatedOtp); // Simulated OTP sending
                setIsVisibleOTP(true);
                setIsVisibleLogin(false);
            }
        } catch (error) {
            console.error("Login error:", error);
        }
    };

    // Generate a 4-digit OTP
    const generateOtp = () => Math.floor(1000 + Math.random() * 9000);

    // Handle OTP verification
    const handleOTP = async () => {
        if (otp === otp2) {
            await createLocalStore();
            await new Promise(resolve => setTimeout(resolve, 100));
            await syncCartAndWishlist();
            navigate("/");
        } else {
            alert("Wrong OTP, please enter a valid OTP!");
        }
    };

    // Handle OTP resend action
    const handleResendOTP = () => {
        alert(`Resend OTP: ${otp2}`);
    };

    return (
        <>
            <Header />
            <div className="bg-light p-4" style={{ marginTop: "110px" }}>
                <div className="col-sm-8 m-auto">
                    <div className="row no-gutters shadow-lg">
                        <div className="col-md-5 d-none d-md-block p-0">
                            <img src="images/login-bg.jpg" className="img-fluid h-100" alt="Login Background" />
                        </div>
                        <div className="col-md-7 bg-white p-5">
                            <div className="box500">
                                {/* Login Form */}
                                <div className={isVisibleLogin ? "show" : "hide"}>
                                    <h4 className="pb-3 text-center">Login to your Account</h4>
                                    <form>
                                        <div className="row_input">
                                            <span className="lbl1">Email/Mobile</span>
                                            <input
                                                type="text"
                                                value={buyerMobile}
                                                placeholder="Enter Email/Mobile"
                                                className="txt1"
                                                onChange={(e) => setBuyerMobile(e.target.value)}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div className="pb-2">
                                            <button
                                                type="submit"
                                                className="btn btn-dark w-100 font-weight-bold mt-2 p-2 rounded-1"
                                                onClick={handleLogin}>
                                                Continue..
                                            </button>
                                        </div>
                                        {errorMessage && <div className="text-danger">{errorMessage}</div>}
                                    </form>
                                    <div className="pt-2 text-center">
                                        <Link className="btn btn-light" to="/buyerSignup">Sign Up</Link>
                                    </div>
                                </div>
                                {/* OTP Verification */}
                                <div className={isVisibleOTP ? "show" : "hide"}>
                                    <div className="otp_icon">
                                        <img src="../../images/icon-otp-verification.svg" alt="OTP Verification" />
                                    </div>
                                    <div className="text-center">
                                        <h5>Verify with OTP (Check your phone)</h5>
                                        <small>We've sent an OTP to {buyerMobile}</small>
                                        <div className="p-4">
                                            <OTPInput
                                                value={otp}
                                                onChange={setOtp}
                                                numInputs={4}
                                                containerStyle="otp_style"
                                                renderSeparator={<span>-</span>}
                                                renderInput={(props) => <input {...props} />}
                                            />
                                            <small className="d-block mt-3">
                                                Didn't get the code?{" "}
                                                <span className="link_btn" onClick={handleResendOTP}>
                                                    Click to resend
                                                </span>
                                            </small>
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn btn-dark w-50 font-weight-bold mt-2 p-2 rounded-1"
                                            onClick={handleOTP}>
                                            Verify
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BuyerLogin;
